<template>
    <div id="accountCreationMobile">
            <div class="content">
                <div class="description">{{ $t("account_creation.description") }}</div>
                <input id="txtNameMobile" type="text" v-model="account.name" :class="{invalid: $validate.error('account.name')}">
                <label for="txtNameMobile">{{ $t("account_creation.name") }}</label>
                <input id="txtAddressMobile" type="text" v-model="account.address" :class="{invalid: $validate.error('account.address')}">
                <label for="txtAddressMobile">{{ $t("account_creation.address") }}</label>
                <input id="txtUnitMobile" type="text" v-model="account.unit" :class="{invalid: $validate.error('account.unit')}">
                <label for="txtUnitMobile">{{ $t("account_creation.unit") }}</label>
                <input id="txtPhoneMobile" type="text" v-model="account.phone" :class="{invalid: $validate.error('account.phone')}">
                <label for="txtPhoneMobile">{{ $t("account_creation.phone") }}</label>
                <textarea name="txtNoteMobile" id="txtNoteMobile" cols="30" rows="10" v-model="account.note"></textarea>
                <label for="txtNoteMobile">{{ $t("account_creation.note") }}</label>
            </div>

            <div class="buttons">
                <div @click="back" class="btn btn-secondary">{{ $t("navigation.back") }}</div>
                <div @click="send" class="btn btn-primary">{{ $t("navigation.send") }}</div>
            </div>

    </div>
</template>

<script>

    export default {

        name: "accountCreationMobile",

        props: {
            account: Object,

            back: Function,
            send: Function,
        },

        validate: {
            "account.name": { required: true },
            "account.address": { required: true },
            "account.unit": { required: true },
            "account.phone": { phone: true }
        },

    }

</script>

<style lang="scss" scoped>

    #accountCreationMobile {
        background-color: #f2f3f4;
        padding: 20px;
    }

    input, textarea, select {
        width: 100%;
    }

    .description {
        margin-bottom: 20px;
    }

    .buttons {
        display: flex;
        margin-top: 8px;
        padding-bottom: 20px;

        .btn {
            flex-grow: 1;
            flex-basis: 0;

            &:not(:last-of-type) {
                margin-right: 20px;
            }
        }
    }

</style>